import { setTransactionsKiosk } from "@actions";
import { connect } from "react-redux";
import BaseTab from "./BaseTab";

class KioskTab extends BaseTab {
  fnDispatch = this.props.setTransactionsKiosk;
}

const mapStateToProps = (state) => {
  return {
    data: state.transactionsKiosk,
    view: state.transactionsView,
    filters: state.transactionsFilters,
  };
};

export default connect(mapStateToProps, { setTransactionsKiosk })(KioskTab);
